import * as Yup from 'yup';

export const sendGridSettingsSchema = Yup.object().shape({
    // Blank = keep the existing stored API key (secrets are no longer returned by the API).
    apiKey: Yup.string(),
    fromEmail: Yup.string().email("Please enter a valid email").required("Please enter from email"),
    apiEndpoint: Yup.string().required("Please enter API endpoint"),
})


